module.exports = __webpack_public_path__ + "static/media/viska@2x.b007295f.png";


//////////////////
// WEBPACK FOOTER
// ./src/viska@2x.png
// module id = 113
// module chunks = 0